import { Button, Form, Input, message, Spin, Upload, Select } from "antd";
import React, { useEffect, useState } from "react";
import { updateCompany } from "../../../api/company";
import { PlusOutlined } from "@ant-design/icons";
import { uploadFile } from "../../../api/file";
import { compressImage } from "../../../lib/utils";
import { Countries, Timezones } from "../../../lib/constants";

export default function CompanyForm({ initialValues }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const countries = Countries;
  const timezones = Timezones.map(tz => ({ label: tz.zone, value: tz.zone }));

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    }
  }, [form, initialValues]);

  const handleSubmit = async (data) => {
    setLoading(true);
    try {
      const logo =
        data.logo && data.logo.length > 0
          ? data.logo.map((file) => {
            if (!file.response) return file;
            return file.response.file;
          })[0]
          : null;

      const formData = {
        id: initialValues.id,
        ...data,
        logo,
      };
      const res = await updateCompany(formData);
      if (res.affected === 1) {
        message.success("Company updated successfully");
      }
    } catch (error) {
      console.error(error);
      message.error("Something went wrong, please try again later");
    } finally {
      setLoading(false);
    }
  };

  const uploadProps = {
    beforeUpload: async (file) => {
      const compressedFile = await compressImage(file);
      return compressedFile;
    },
    customRequest: async ({ file, onSuccess, onError }) => {
      try {
        const res = await uploadFile(file, { entity: "company" });
        onSuccess(res);
      } catch (err) {
        onError(err);
      }
    },
    listType: "picture-card",
    multiple: false,
    maxCount: 1,
    accept: "image/*",
  };

  return (
    <div>
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          name={"logo"}
          label="Company Logo"
          valuePropName="fileList"
          getValueFromEvent={(e) => e.fileList}
          className="col-span-2"
        >
          <Upload {...uploadProps}>
            <PlusOutlined className="mr-1" />
            Upload
          </Upload>
        </Form.Item>

        <Form.Item
          name="name"
          label="Company Name"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="phone"
          label="Phone Number"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item name="address" label="Address" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item
          name="country"
          label="Country"
          rules={[{ required: true }]}
        >
          <Select
            showSearch
            placeholder="Select a country"
            options={countries}
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>

        <Form.Item
          name="timezone"
          label="Timezone"
          rules={[{ required: true }]}
        >
          <Select
            showSearch
            placeholder="Select a timezone"
            options={timezones}
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>

        <Form.Item>
          <Button disabled={loading} type="primary" htmlType="submit">
            {loading ? <Spin /> : "Update"}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}